import { Customer } from './Customer';
import { PermissionInfo } from './PermissionInfo';
import { ProfileUser } from './ProfileUser';

export class ExtendedProfile {
  public id: string = '';
  public subject: string = '';
  public status: string = '';
  public role: string = '';
  public customer: Customer = new Customer();
  public user: ProfileUser = new ProfileUser();
  public permissionInfo: PermissionInfo = new PermissionInfo();
  public isCarrier: boolean;

  public isActive: boolean = false;
  public hasShopAccess: boolean = false;
}
